import React, { useState } from "react";
import { Box, Typography, IconButton, Stack } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";

const DropBox = styled(Box)({
  boxSizing: "border-box",
  // border: "2px dashed #cccccc",
  borderRadius: 8,
  width: "100%",
  padding: 50,
  textAlign: "center",
  cursor: "pointer",
  transition: "background-color 0.2s, border-color 0.2s",
});

const Thumbnail = styled(Box)({
  position: "relative",
  width: 100,
  height: 100,
  margin: 8,
  border: "1px solid #ccc",
  borderRadius: 8,
  overflow: "hidden",
  backgroundColor: "#f9f9f9",
  "& img": { width: "100%", height: "100%", objectFit: "cover" },
});

const RemoveButton = styled(IconButton)({
  position: "absolute",
  top: 4,
  right: 4,
  backgroundColor: "rgba(255,255,255,0.8)",
});

const FileUpload = ({ allowMultiple = false, onRemoveFile, onFileChange, title }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = (filesArray) => {
    const previews = filesArray.map((file) => ({
      file,
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : file.type === "application/pdf"
        ? "/assets/pdf.png"
        : null,
    }));
    setSelectedFiles(previews);
    onFileChange(filesArray);
  };

  const handleFileChange = (e) => handleFiles(Array.from(e.target.files));

  const handleRemove = (idx) => {
    const updated = selectedFiles.filter((_, i) => i !== idx);
    setSelectedFiles(updated);
    onRemoveFile();
  };

  const dragEvents = {
    onDragEnter: (e) => { e.preventDefault(); setIsDragging(true); },
    onDragLeave: (e) => { e.preventDefault(); setIsDragging(false); },
    onDragOver: (e) => e.preventDefault(),
    onDrop: (e) => {
      e.preventDefault();
      setIsDragging(false);
      handleFiles(Array.from(e.dataTransfer.files));
    },
  };

  return (
    <Stack gap={2} width="100%">
      <Typography variant="subtitle1" color="white" fontWeight="bold">
        {title}
      </Typography>

      <DropBox
        {...dragEvents}
        sx={{
          borderColor: isDragging ? "primary.main" : undefined,
          backgroundColor: "#f9f9f9",
        }}
      >
        <input
          id="fileInput"
          type="file"
          multiple={allowMultiple}
          accept=".pdf,.jpg,.jpeg,.png,.docx"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
          <CloudUploadIcon fontSize="large" />
          <Typography variant="h6">Dra eller välj{allowMultiple ? "s" : ""}</Typography>
          <Typography variant="body2">Släpp filer här eller klicka för att bläddra</Typography>
        </label>
      </DropBox>

      {selectedFiles.length > 0 && (
        <Box display="flex" flexWrap="wrap">
          {selectedFiles.map((fileObj, i) => (
            <Thumbnail key={i}>
              {fileObj.preview ? (
                <img src={fileObj.preview} alt={fileObj.file.name} />
              ) : (
                <Typography variant="caption">{fileObj.file.name}</Typography>
              )}
              <RemoveButton size="small" onClick={() => handleRemove(i)}>
                <CloseIcon fontSize="small" />
              </RemoveButton>
            </Thumbnail>
          ))}
        </Box>
      )}
    </Stack>
  );
};

export default FileUpload;
